export default __webpack_public_path__ + "static/media/bearer-logo.2f3153a7.svg";